(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-product"] && !Shopify.designMode) return;
  try {
    
  (function(){
    document.querySelectorAll('[data-rp-gallery]').forEach(function(gal){
      var media = gal.closest('.rp-media');
      var dots = media.querySelectorAll('[data-rp-gal-dot]');
      function idx(){ return Math.round(gal.scrollLeft / (gal.clientWidth || 1)); }
      function go(i){
        var n = gal.children.length;
        i = (i + n) % n;
        gal.scrollTo({ left: i * gal.clientWidth, behavior: 'smooth' });
      }
      gal.addEventListener('scroll', function(){
        var i = idx();
        dots.forEach(function(d, k){ d.classList.toggle('is-active', k === i); });
      }, { passive: true });
      var prev = media.querySelector('[data-rp-gal-prev]');
      var next = media.querySelector('[data-rp-gal-next]');
      if (prev) prev.addEventListener('click', function(){ go(idx() - 1); });
      if (next) next.addEventListener('click', function(){ go(idx() + 1); });
      dots.forEach(function(d){ d.addEventListener('click', function(){ go(parseInt(d.getAttribute('data-rp-gal-dot'), 10)); }); });
      gal.rpGoToMedia = function(id){
        var slides = Array.prototype.slice.call(gal.children);
        for (var k = 0; k < slides.length; k++) {
          if (slides[k].getAttribute('data-media-id') === String(id)) { go(k); return; }
        }
      };
    });
  })();
  (function(){
    document.querySelectorAll('[data-rp-product-form]').forEach(function(root){
      var section = root.closest('.rp-section');
      var variantsEl = section.querySelector('[data-rp-variants]');
      var variants = variantsEl ? JSON.parse(variantsEl.textContent) : [];
      var currentOptionsEl = section.querySelector('[data-rp-current-options]');
      var selectedOptions = currentOptionsEl ? JSON.parse(currentOptionsEl.textContent) : [];

      var variantInput = root.querySelector('[data-rp-variant-input]');
      var buyBtn = root.querySelector('[data-rp-buy-button]');
      var buyText = root.querySelector('[data-rp-buy-text]');

      function findVariant(){
        return variants.filter(function(v){
          return v.options.length === selectedOptions.length && v.options.every(function(val, idx){ return val === selectedOptions[idx]; });
        })[0];
      }

      function applyVariant(variant){
        var label = buyBtn ? (buyBtn.getAttribute('data-label') || 'Ajouter au panier') : 'Ajouter au panier';
        var soldOutLabel = buyBtn ? (buyBtn.getAttribute('data-sold-out-label') || 'Sold out') : 'Sold out';

        if(!variant){
          if(buyBtn) buyBtn.disabled = true;
          if(buyText) buyText.textContent = soldOutLabel;
          return;
        }
        if(variantInput) variantInput.value = variant.id;
        var galEl = section.querySelector('[data-rp-gallery]');
        if(galEl && galEl.rpGoToMedia && variant.media_id) galEl.rpGoToMedia(variant.media_id);
        var priceEl = section.querySelector('[data-rp-price]');
        if(priceEl) priceEl.textContent = variant.price;
        var stockEl = section.querySelector('[data-rp-stock]');
        if(stockEl){
          var thr = parseInt(stockEl.getAttribute('data-threshold'), 10) || 5;
          var low = variant.tracked && variant.available && variant.qty > 0 && variant.qty <= thr;
          stockEl.hidden = !low;
          if(low){
            var stockTxt = stockEl.querySelector('[data-rp-stock-text]');
            if(stockTxt) stockTxt.textContent = (stockEl.getAttribute('data-text') || 'Plus que [qty] en stock').replace('[qty]', variant.qty);
          }
        }
        var stickyPrice = document.querySelector('[data-rp-sticky-price]');
        if(stickyPrice) stickyPrice.textContent = variant.price;
        var stickyBtn = document.querySelector('[data-rp-sticky-btn]');
        if(stickyBtn){
          stickyBtn.disabled = !variant.available;
          stickyBtn.textContent = variant.available ? (stickyBtn.getAttribute('data-label') || stickyBtn.textContent) : soldOutLabel;
        }
        if(buyBtn) buyBtn.disabled = !variant.available;
        if(buyText){
          if(!variant.available){
            buyText.textContent = soldOutLabel;
          } else {
            buyText.textContent = label;
          }
        }
      }

      function openThemeCartDrawer(addedItem){
        var cartDrawer = document.querySelector('cart-drawer');
        if (cartDrawer && typeof cartDrawer.handleAddedItem === 'function') {
          cartDrawer.handleAddedItem(addedItem);
          return;
        }
        if (cartDrawer && typeof cartDrawer.open === 'function') {
          cartDrawer.open();
          return;
        }
        var openBtn = document.querySelector('[data-js-cart-drawer="cartDrawerOpen"]');
        if (openBtn) openBtn.click();
      }

      // ---- Ajout au panier du produit principal : AJAX + ouverture du cart-drawer ----
      var mainForm = root.querySelector('form');
      if(mainForm){
        mainForm.addEventListener('submit', function(e){
          e.preventDefault();
          e.stopPropagation();
          if(typeof e.stopImmediatePropagation === 'function') e.stopImmediatePropagation();

          if(!variantInput || !variantInput.value){
            console.error('rhode-style-product: aucun ID de variante à ajouter au panier');
            return;
          }

          var urlScript = section.querySelector('[data-rp-cart-add-url]');
          var addUrl = urlScript ? JSON.parse(urlScript.textContent) : '/cart/add.js';
          // Ajax API : `/cart/add.js` renvoie le line item complet (image).
          // `routes.cart_add_url` = `/cart/add` (HTML) → JSON sans image.
          if (addUrl && addUrl.indexOf('/cart/add.js') === -1) {
            addUrl = addUrl.replace(/\/cart\/add\/?(\?|$)/, '/cart/add.js$1');
          }
          var originalHtml = buyText ? buyText.innerHTML : '';
          if(buyBtn) buyBtn.disabled = true;

          var payload = { id: parseInt(variantInput.value, 10), quantity: 1 };
          var cartDrawer = document.querySelector('cart-drawer');
          if (cartDrawer && typeof cartDrawer.getSectionsToRender === 'function') {
            var sectionIds = cartDrawer.getSectionsToRender().map(function(s){ return s.section; }).filter(Boolean);
            if (sectionIds.length) {
              payload.sections = sectionIds;
              payload.sections_url = window.location.pathname;
            }
          }

          fetch(addUrl, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify(payload)
          })
          .then(function(res){
            return res.json().then(function(data){
              if(!res.ok) throw new Error(data.description || 'Erreur ajout panier');
              return data;
            });
          })
          .then(function(data){
            document.dispatchEvent(new CustomEvent('cart:refresh'));
            if(buyText) buyText.textContent = (buyBtn && buyBtn.getAttribute('data-added-label')) || 'Ajouté au panier ✓';
            showToast((buyBtn && buyBtn.getAttribute('data-added-label')) || 'Ajouté au panier ✓');
            openThemeCartDrawer(data);
            if(buyBtn) buyBtn.disabled = false;
            setTimeout(function(){
              if(buyText) buyText.innerHTML = originalHtml;
            }, 1800);
          })
          .catch(function(err){
            console.error('rhode-style-product: erreur ajout panier produit principal', err);
            if(buyBtn) buyBtn.disabled = false;
            if(buyText) buyText.innerHTML = originalHtml;
            alert(err.message || 'Impossible d\'ajouter ce produit au panier.');
          });
        });
      }

      // ---- Barre d'achat collante (mobile) : visible quand le bouton principal sort de l'écran ----
      var sticky = section.querySelector('[data-rp-sticky]');
      if(sticky && buyBtn){
        if(sticky.parentNode !== document.body) document.body.appendChild(sticky);
        var stickyBtnEl = sticky.querySelector('[data-rp-sticky-btn]');
        if(stickyBtnEl) stickyBtnEl.addEventListener('click', function(){
          if(stickyBtnEl.disabled || !mainForm) return;
          if(typeof mainForm.requestSubmit === 'function') mainForm.requestSubmit();
          else mainForm.dispatchEvent(new Event('submit', { cancelable: true }));
        });
        if('IntersectionObserver' in window){
          var io = new IntersectionObserver(function(entries){
            entries.forEach(function(en){
              var show = !en.isIntersecting;
              sticky.classList.toggle('is-visible', show);
              document.body.classList.toggle('rp-sticky-on', show && window.innerWidth <= 860);
              sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
              if(stickyBtnEl) stickyBtnEl.tabIndex = show ? 0 : -1;
            });
          });
          io.observe(buyBtn);
        }
      }

      section.querySelectorAll('[data-rp-pills]').forEach(function(pillsWrap){
        var pillIndex = parseInt(pillsWrap.getAttribute('data-option-index'), 10);
        var pills = pillsWrap.querySelectorAll('.rp-pill');
        pills.forEach(function(pill){
          pill.addEventListener('click', function(){
            pills.forEach(function(p){ p.classList.remove('is-selected'); p.removeAttribute('aria-pressed'); });
            pill.classList.add('is-selected');
            pill.setAttribute('aria-pressed', 'true');
            selectedOptions[pillIndex] = pill.getAttribute('data-option-value');
            applyVariant(findVariant());
          });
        });
      });

      // ---- Accordéons : un seul ouvert à la fois (l'animation de descente est en CSS) ----
      // + scroll automatique en douceur dans le panneau pour amener l'accordéon ouvert en haut
      var accordions = section.querySelectorAll('.rp-accordion');
      var infoPanel = section.querySelector('.rp-info');

      function scrollAccordionIntoView(acc){
        if(!infoPanel) return;
        var summary = acc.querySelector('summary');
        if(!summary) return;
        var panelRect = infoPanel.getBoundingClientRect();
        var summaryRect = summary.getBoundingClientRect();
        var delta = summaryRect.top - panelRect.top;
        var maxScrollTop = infoPanel.scrollHeight - infoPanel.clientHeight;
        var targetTop = infoPanel.scrollTop + delta - 8;
        targetTop = Math.max(0, Math.min(targetTop, maxScrollTop));
        infoPanel.scrollTo({ top: targetTop, behavior: 'smooth' });
      }

      // Attend la VRAIE fin de l'animation de fermeture d'un accordéon (transitionend
      // sur grid-template-rows) avant d'appeler le callback, avec un filet de sécurité
      // (setTimeout) au cas où la transition ne se déclenche pas (ex: mouvement réduit).
      // Un simple délai fixe (ex: 370ms) est trop fragile : le calcul de position peut
      // parfois se faire un instant trop tôt sur un agencement pas encore stabilisé,
      // ce qui donnait le bug "ça descend pas toujours".
      function whenAccordionClosed(other, callback){
        var content = other.querySelector('.rp-accordion-content');
        var done = false;
        function finish(){
          if(done) return;
          done = true;
          if(content) content.removeEventListener('transitionend', onTransitionEnd);
          callback();
        }
        function onTransitionEnd(e){
          if(e.propertyName === 'grid-template-rows') finish();
        }
        if(content) content.addEventListener('transitionend', onTransitionEnd);
        setTimeout(finish, 450);
      }

      accordions.forEach(function(acc){
        acc.addEventListener('toggle', function(){
          if(acc.open){
            var others = [];
            accordions.forEach(function(other){
              if(other !== acc && other.open){
                others.push(other);
                other.removeAttribute('open');
              }
            });

            if(others.length === 0){
              scrollAccordionIntoView(acc);
            } else {
              var remaining = others.length;
              others.forEach(function(other){
                whenAccordionClosed(other, function(){
                  remaining -= 1;
                  if(remaining === 0) scrollAccordionIntoView(acc);
                });
              });
            }
          }
        });
      });

      // ---- Popups (blocs "Bloc popup") ----
      section.querySelectorAll('[data-rp-popup-open]').forEach(function(btn){
        btn.addEventListener('click', function(){
          var dialog = document.getElementById(btn.getAttribute('data-rp-popup-open'));
          if(dialog && dialog.showModal) dialog.showModal();
        });
      });
      section.querySelectorAll('[data-rp-popup-close]').forEach(function(btn){
        btn.addEventListener('click', function(){
          var dialog = btn.closest('dialog');
          if(dialog) dialog.close();
        });
      });
      section.querySelectorAll('[data-rp-popup]').forEach(function(dialog){
        dialog.addEventListener('click', function(e){
          if(e.target === dialog) dialog.close();
        });
      });

      // ---- Notification toast ----
      function showToast(message){
        var toast = section.querySelector('[data-rp-toast]');
        if(!toast) return;
        toast.textContent = message;
        toast.classList.add('is-visible');
        clearTimeout(toast._rpHideTimeout);
        toast._rpHideTimeout = setTimeout(function(){ toast.classList.remove('is-visible'); }, 2500);
      }

      // ---- Recommandations Shopify natives (Search & Discovery) : chargées en AJAX ----
      var recoWrap = section.querySelector('[data-rp-recommendations-wrap]');
      var recoContainer = section.querySelector('[data-rp-recommendations]');
      if(recoWrap && recoContainer){
        var recoUrl = recoContainer.getAttribute('data-url');
        fetch(recoUrl)
          .then(function(res){ return res.text(); })
          .then(function(html){
            var temp = document.createElement('div');
            temp.innerHTML = html;
            var grid = temp.querySelector('.rp-routine-grid');
            if(grid){
              recoContainer.innerHTML = grid.outerHTML;
              recoWrap.style.display = '';
            }
          })
          .catch(function(err){
            console.error('rhode-style-product: erreur chargement recommandations', err);
          });
      }

      // ---- "Select items" : ajoute les produits recommandés cochés au panier ----
      var selectBtn = section.querySelector('[data-rp-select-items]');
      if(selectBtn){
        function getCheckboxes(){
          return section.querySelectorAll('[data-rp-routine-checkbox]');
        }
        function refreshSelectBtn(){
          var any = Array.prototype.some.call(getCheckboxes(), function(c){ return c.checked; });
          selectBtn.disabled = !any;
        }
        section.addEventListener('change', function(e){
          if(e.target.matches && e.target.matches('[data-rp-routine-checkbox]')) refreshSelectBtn();
        });

        selectBtn.addEventListener('click', function(){
          var items = [];
          getCheckboxes().forEach(function(c){
            if(c.checked){
              var card = c.closest('[data-rp-routine-card]');
              var selectEl = card ? card.querySelector('[data-rp-routine-select]') : null;
              if(selectEl && selectEl.value){
                items.push({ id: parseInt(selectEl.value, 10), quantity: 1 });
              }
            }
          });
          if(items.length === 0) return;

          var urlScript = section.querySelector('[data-rp-cart-add-url]');
          var addUrl = urlScript ? JSON.parse(urlScript.textContent) : '/cart/add.js';
          var originalLabel = selectBtn.textContent;
          selectBtn.disabled = true;

          fetch(addUrl, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items: items })
          })
          .then(function(res){
            return res.json().then(function(data){
              if(!res.ok) throw new Error(data.description || 'Erreur ajout panier');
              return data;
            });
          })
          .then(function(){
            selectBtn.textContent = selectBtn.getAttribute('data-success-label') || 'Added';
            selectBtn.classList.add('is-success');
            document.dispatchEvent(new CustomEvent('cart:refresh'));
            showToast(section.getAttribute('data-added-toast') || 'Produits ajoutés au panier ✓');
            getCheckboxes().forEach(function(c){ c.checked = false; });
            setTimeout(function(){
              selectBtn.textContent = originalLabel;
              selectBtn.classList.remove('is-success');
              refreshSelectBtn();
            }, 1800);
          })
          .catch(function(err){
            console.error('rhode-style-product: erreur ajout panier', err);
            selectBtn.disabled = false;
            selectBtn.textContent = originalLabel;
            showToast(err.message || 'Erreur lors de l\'ajout au panier');
          });
        });
      }
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
